module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-icon-1.bc1d488f3fe5dfd686fc32ad87e4f6c7.png";